import React, { FC } from 'react';
import { Remote } from '@okapi/remote';
import { BasketLogicProps } from '../types';

const BasketLogic: FC<BasketLogicProps> = ({ serverTimeout }) => {
  return <Remote widget="basket-logic/basket-logic" id="basket-logic" serverTimeout={serverTimeout} />;
};

export { BasketLogic };
